import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AssetManager } from 'src/app/asset-manager/asset-manager';
import { IInspectionPlan } from 'src/app/inspection-plan/inspection-plan.interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InspectionPlanAssistantService {

  constructor(
    private assetManager: AssetManager,
    private http: HttpClient  
  ) { }

  private inspectionPlanReferenceDateUpdated = new BehaviorSubject(this.assetManager.referenceDate)
  castInspectionPlanReferenceDate = this.inspectionPlanReferenceDateUpdated.asObservable()  

  public setInspectionPlanReferenceDate(value: Date) {
    this.inspectionPlanReferenceDateUpdated.next(value)
  }

  public getInspectionPlanReferenceDate() {
    return this.inspectionPlanReferenceDateUpdated
  }

  getOpenPlansOutsideCurrentDate(assetId: string, regionIds: string[], referenceDate: Date, inspectionTypeId: string) {
    const regionIdsMerged = regionIds.join(',')
    return this.http.get<IInspectionPlan[]>(environment.API_INSPEC + 
      `InspectionPlan/GetOpenPlansOutsideCurrentDate`+
      `?assetId=${assetId}`+
      `&regionIds=${regionIdsMerged}`+
      `&currentDate=${referenceDate.toJSON()}`+
      `&inspectionTypeId=${inspectionTypeId}`
    )
  }

}
